export default {
    // 获取列表信息
    getDictValuesByTag(params, response) {
        window.vue.$apiAxios.get('/setting/dictController/getDictValuesByTag', params, response);
    },
    // 获取列表信息
    getListInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/dbTask/list', params, response);
    },
    // 添加/编辑列表信息
    addDbTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/dbTask/save', params, response);
    },
    // 编辑时获取单条详细信息
    getSingleListInfo(params) {
    },
    // 删除列表信息
    deleteDbTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/dbTask/delete', params, response);
    },
    // 测试sql语句
    testSQL(params, response) {
        window.vue.$apiAxios.postRequestBody('/dbTask/excuteSql', params, response);
    },
};
